import React from 'react';
import { cn } from '@/utils/common-helpers';
import Image from 'next/image';

export function FeaturesSectionHoverEffectsDjango() {
    const features = [
        {
            title: 'Django Web App Development',
            description:
                'We\'re a top-tier Django web development company committed to creating cutting-edge solutions with stunning UX/UI. Our Django developers develop dynamic web applications that work on Windows, Linux, or Mac and support many databases.',
            icon: '/img/technology/ic-consulting-services.svg',
        },
        {
            title: 'Django Mobile App Development',
            description:
                'We have the best Django developers all set to build the backend for mobile apps using Django REST frameworks and integrate it with modern in-demand frontend technologies.',
            icon: '/img/technology/ic-development.svg',
        },
        {
            title: 'Django API Development',
            description:
                'Apart from app development, our team of Django developers can build Restful APIs that will boost your custom software integration. We can empower your online presence by digitally fortifying it with Django web development solutions.',
            icon: '/img/technology/ic-spas.svg',
        },
        {
            title: 'Migration to Django',
            description:
                "We can facilitate you to migrate your current framework to Django by ensuring total transparency and a glitch-free experience. Hire Django experts from Moweb to streamline the entire Django migration process without any data loss and downtime.",
            icon: '/img/technology/ic-portaldevelopment.svg',
        },
        {
            title: 'Django Ecommerce App Development',
            description:
                'Our Django developers build highly scalable, powerful, and intuitive eCommerce applications. With our top Django eCommerce development solutions, you can get an eCommerce website or app to spike your online store sales.',
            icon: '/img/technology/ic-webapp.svg',
        },
        {
            title: 'Django Support & Maintenance',
            description:
                'We provide a full range of Django support and maintenance services to improve operational agility, resolve unresolved business challenges, and reduce costs. We ensure the prompt resolution of any issues that arise after the launch.',
            icon: '/img/technology/ic-migration-upgradation.svg',
        },
    ];
    return (
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3  relative z-10 max-w-7xl mx-auto">
            {features.map((feature, index) => (
                <Feature key={feature.title} {...feature} index={index} total={features.length} />
            ))}
        </div>
    );
}

const Feature = ({
    title,
    description,
    icon,
    index,
    total,
}: {
    title: string;
    description: string;
    icon: string;
    index: number;
    total: number;
}) => {
    return (
        <div
            className={cn(
                'flex flex-col py-[30px] relative group/feature dark:border-neutral-800',
                index % 3 === 0 && 'lg:border-l dark:border-neutral-800',
                (index + 1) % 3 !== 0 && 'lg:border-r dark:border-neutral-800',
                index >= 3 && 'lg:border-t dark:border-neutral-800 ',
                index === 5 && 'dark:border-neutral-800 ',
                index === 5 && total % 2 === 0 && 'mb-[-1.2px]',
            )}
        >
            {index < 3 && (
                <div className="opacity-0 group-hover/feature:opacity-100 transition duration-200 absolute inset-0 h-full w-full bg-gradient-to-t from-[#F5F6F9] dark:from-neutral-800 to-transparent pointer-events-none" />
            )}
            {index >= 3 && (
                <div className="opacity-0 group-hover/feature:opacity-100 transition duration-200 absolute inset-0 h-full w-full bg-gradient-to-b from-[#F5F6F9] dark:from-neutral-800 to-transparent pointer-events-none" />
            )}
            <div className="mb-[10px] relative z-10 px-10 text-neutral-600 dark:text-neutral-400">
                <Image src={icon} width={36} height={36} alt={title} title={title} className="" />
            </div>
            <div className="text-2xl font-bold mb-[10px] relative z-10 px-[30px]">
                <div className="absolute left-0 inset-y-0 h-6 group-hover/feature:h-8 w-1 rounded-tr-full rounded-br-full bg-neutral-300 dark:bg-neutral-700 group-hover/feature:bg-primary transition-all duration-200 origin-center" />
                <span className="group-hover/feature:translate-x-2 group-hover/feature:text-primary transition duration-200 inline-block text-neutral-800 dark:text-neutral-100">
                    {title}
                </span>
            </div>
            <p className="text-[#4C5773] mb-0 text-base text-neutral-600 dark:text-neutral-300 relative z-10 px-[30px]">
                {description}
            </p>
        </div>
    );
};
